import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import { capitalizeIfLower } from '@btime/helpers'
import React from 'react'

import { SmallText, Title } from '../../../../components/presentation/Text'
import { usePlaceLevels } from '../../_load/PlaceLevelsLoader'
import CardSelector from '../../../../components/form/CardSelector'
import ControlBar from './ControlBar'
import Icon from '../../../../components/shapes/Icon'
import TagPicker from '../../../../components/form/TagPicker'

const PlaceLevelCardSelector = ({ option, ...props }) => {
  const body = (
    <div>
      <Title size="h6" bold noMargin>
        {option.label}
      </Title>
      <SmallText color={COLORS.dark3}>{option.subtitle}</SmallText>
    </div>
  )

  const head = <Icon name={option.icon} color={COLORS.dark4} />

  return <CardSelector head={head} body={body} width="25%" widthOnSm="50%" {...props} />
}

const PlacesLevelsPicker = ({ selectedLabel, ...props }) => {
  const placesLevels = usePlaceLevels()

  if (props.value == 'all') return false

  const options = placesLevels.map(item => ({
    label: item.name ? `${capitalizeIfLower(item.level?.name)}: ${capitalizeIfLower(item.name)}` : '',
    subtitle: item.resume,
    icon: item.type === 'person' ? 'BsPersonSquare' : 'BsBuilding',
    value: props.idField ? item : item.id,
    origin: item
  }))

  return <TagPicker options={options} Selector={PlaceLevelCardSelector} {...props} />
}

const Wrapper = ({ selectedLabel, useSelectAll, ...props }) => (
  <FilterHandler>
    <ControlBar
      selectedLabel={selectedLabel}
      useSelectAll={useSelectAll}
      value={props.value}
      onChange={props.onChange}
      disabledLoader={props.value == 'all'}
    >
      <PlacesLevelsPicker {...props} />
    </ControlBar>
  </FilterHandler>
)

export default Wrapper
